const KEY = "navigation-stack";
const MAX = 200;

export function readStack(): string[] {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}
export function writeStack(stack: string[]) {
  if (stack.length > MAX) stack = stack.slice(stack.length - MAX);
  sessionStorage.setItem(KEY, JSON.stringify(stack));
}

export function pushPath(path: string) {
  const stack = readStack();
  if (stack[stack.length - 1] !== path) {
    writeStack([...stack, path]);
  }
}

export function replaceTop(path: string) {
  const stack = readStack();
  if (stack.length === 0) {
    writeStack([path]);
  } else if (stack[stack.length - 1] !== path) {
    stack[stack.length - 1] = path;
    writeStack(stack);
  }
}

export function popPrev(): string | null {
  const stack = readStack();
  if (stack.length <= 1) return null;
  stack.pop();
  const prev = stack[stack.length - 1] ?? null;
  writeStack(stack);
  return prev;
}
